import { ScanLine, ClipboardList, Sliders, History, type LucideIcon } from 'lucide-react';
import DoricColumn from './DoricColumn';

interface Row {
  verb: string;
  Icon: LucideIcon;
  body: string;
}

const ROWS: Row[] = [
  {
    verb: 'Analyzes',
    Icon: ScanLine,
    body: 'Day one. A photo + simple onboarding plots your starting line — we find your weak points, strengths, bf %, break down everything you need to know about where you stand. You tell us goals, training style, equipment, weight and height, and we get to work.',
  },
  {
    verb: 'Prescribes',
    Icon: ClipboardList,
    body: "Tuesday — push day. You're learning to handstand and planche from the skill tree, calibrated to fit in seamlessly with your current workout plan, and you're set to finish a great workout with some mobility and stretching work.",
  },
  {
    verb: 'Adapts',
    Icon: Sliders,
    body: "You pushed the limits on yesterday's workout. Today's load drops 5% and rest increases slightly while focusing on technique and slow tempo.",
  },
  {
    verb: 'Remembers',
    Icon: History,
    body: "Two years in. The shoulder you tweaked last winter no longer bugs you. You've hit 225lbs on the bench press as the program has broken through your plateau. Every exercise, every rep, style, structure, rest, all of it, still here, still improving how you train today.",
  },
];

export default function WhatItDoes() {
  return (
    <section className="relative border-t border-[rgba(43,36,20,0.18)] px-6 py-24 sm:py-28">
      <DoricColumn className="absolute left-16 top-0 bottom-0 hidden lg:block" />
      <DoricColumn className="absolute right-16 top-0 bottom-0 hidden lg:block" />

      <div className="mx-auto max-w-3xl">
        <h2
          className="m-0 text-[#2B2414] font-display"
          style={{
            fontWeight: 400,
            fontSize: 'clamp(32px, 4.4vw, 44px)',
            lineHeight: 1.1,
            letterSpacing: '-0.024em',
          }}
        >
          What it does.
        </h2>

        <dl className="mt-16 flex flex-col">
          {ROWS.map(({ verb, Icon, body }, i) => (
            <div
              key={verb}
              className={`flex flex-col gap-5 py-12 sm:flex-row sm:gap-16 ${
                i > 0 ? 'border-t border-[rgba(43,36,20,0.10)]' : ''
              }`}
            >
              <dt className="shrink-0 sm:w-[180px] sm:pt-1">
                <Icon
                  size={20}
                  strokeWidth={1.5}
                  className="mb-4 text-[#7B7162]"
                  aria-hidden="true"
                />
                <span
                  className="block text-[#2B2414] font-mono"
                  style={{
                    fontWeight: 500,
                    fontSize: 14,
                    letterSpacing: '0.14em',
                    textTransform: 'uppercase',
                  }}
                >
                  {verb}
                </span>
              </dt>
              <dd
                className="m-0 text-[#3D3526] font-body"
                style={{
                  fontWeight: 400,
                  fontSize: 17,
                  lineHeight: 1.75,
                  letterSpacing: '-0.011em',
                }}
              >
                {body}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
